<template>
  <div class="model-bd" :style="styleObj">
    <div class="cont-comp-loading" v-if="loading">
      <a-spin :spinning="loading"></a-spin>
    </div>
    <div class="widget-time" v-show="dateRang && dateRang.length > 0">
			<TagDateRange size="small" v-model="dateRang"  @change="onChange"></TagDateRange>
    </div>
    <v-chart :options="options" autoresize/>
  </div>
</template>

<script>
import moment from 'moment';
import TagDateRange from "@/components/TagDateRange";

export default {
  name: "WidgetPiechart",
  components: {
    TagDateRange
  },
  props: {
    value: Object,
    ispreview: Boolean
  },
  data() {
    return {
      options: {
        title: {
          text: "",
          left: "center",
          textStyle: {
            color: "#fff"
          }
        },
        // legend: {
        //   orient: "vertical",
        //   left: "left",
        //   textStyle: {
        //     color: "#fff"
        //   }
        // },
        series: [
          {
            type: "pie",
            radius: "50%",
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      },
      optionsStyle: {}, // 样式
      optionsData: {}, // 数据
      optionsSetup: {},
      // 时间组件
      dateRang: [],
      loading: false,
      timeSelector: "",
      flag: false,
    };
  },
  inject: ["getDashboardDynamicData", "getFilterCondition"],
  computed: {
    dashbordData() {
      return this.getDashboardDynamicData()?.contextData || {}
    },
    styleObj() {
      return {
        position: this.ispreview ? "absolute" : "static",
        width: this.optionsStyle.width + "px",
        height: this.optionsStyle.height + "px",
        left: this.optionsStyle.left + "px",
        top: this.optionsStyle.top + "px",
        background: this.optionsSetup.background
      };
    }
  },
  watch: {
    value: {
      handler(val) {
        this.optionsStyle = val.position;
        let flag = this.optionsData === val.data && !this.optionsData?.dynamicData?.chartProperties?.isVerified
        this.optionsData = val.data;
        this.optionsSetup = val.setup;
        if(this.ispreview && this.isContCompDate(this.optionsData)) {
          // console.log(222)
        }else {
          this.editorOptions(flag);
          this.editorDataSet();
        }
        
      },
      deep: true
    }
  },
  created() {
    this.optionsStyle = this.value.position;
    this.optionsData = this.value.data;
    this.optionsSetup = this.value.setup;
    this.editorOptions();
  },
  methods: {
    disabledDate(current) {
      return current && current > moment().endOf('day');
    },
    filterSearch() {
      this.getEchartData(this.optionsData.dynamicData, this.optionsSetup);
    },
    onChange(val, timeSelector) {
      if(this.ispreview){
        console.log(val);
        console.log(this.dateRang);
        const optionsSetup = this.optionsSetup;
        const optionsData = this.optionsData;
        const dataSet = this.optionsData.dynamicData.contextData;
        dataSet.dateRang.from = val[0];
        dataSet.dateRang.to = val[1];
        dataSet.dateRang.timeSelector = timeSelector;
        // this.editorDataSet();
        this.getEchartData(optionsData.dynamicData, optionsSetup);
      }
    },
    editorDataSet(){
      // 获取数据的配置项；
      const dataSet = this.optionsData.dynamicData.contextData;
      // 设置日期响应
      if(!!dataSet && dataSet.dateRang.from && dataSet.dateRang.to){
        let dateRang = [];
        dateRang[0] = dataSet.dateRang.from;
        dateRang[1] = dataSet.dateRang.to;
        this.$set(this.dateRang, 0, dateRang[0])
        this.$set(this.dateRang, 1, dateRang[1])
        this.timeSelector = dataSet.dateRang.timeSelector
      }else {
        this.dateRang = [];
        this.timeSelector = ''
      }
    },
    previewInit(data) {
      if(this.isContCompDate(this.optionsData)){
        // const that  = this;
        if(!this.flag){
          this.setPieFromResponse(data)
          this.flag = true;
        }
      }else {
        this.setPieFromResponse(data)
      }
    },
    setPieFromResponse(res) {
      const combineData = this.piechartFn(res);
      new Promise((resolve, reject) => {
        resolve(combineData)
      }).then(response => {
        this.renderingFn(response);
      })
    },
    // 修改图标options属性
    editorOptions(flag) {
      this.setOptionsTitle();
      this.setOptionsValue();
      this.setOptionsTooltip();
      this.setOptionsMargin();
      // this.setOptionsLegend();
      this.setOptionsColor();
      this.setOptionsPiechartStyle();
      !flag&&this.setOptionsData();
    },
    // 饼图样式
    setOptionsPiechartStyle() {
      if (this.optionsSetup.piechartStyle == "shixin") {
        this.options.series[0]["radius"] = "50%";
      } else if (this.optionsSetup.piechartStyle == "kongxin") {
        this.options.series[0]["radius"] = ["20%", "50%"];
      }
    },
    // 边距设置
    setOptionsMargin() {
      const optionsSetup = this.optionsSetup;
      // debugger;
      const grid = {
        left: optionsSetup.marginLeft || 24,
        right: optionsSetup.marginRight || 24,
        bottom: optionsSetup.marginBottom || 44,
        top: optionsSetup.marginTop || 76,
        containLabel: true,
      };
      this.options.grid = grid;
    },
    // 标题设置
    setOptionsTitle() {
      const optionsSetup = this.optionsSetup;
      const title = {};
      title.show = true;
      title.text = optionsSetup.titleText;
      title.left = optionsSetup.textAlign || 'left';
      title.textStyle = {
        color: optionsSetup.textColor || "#13234C",
        fontSize: optionsSetup.textFontSize || 16,
        fontWeight: optionsSetup.textFontWeight || 400,
      };
      title.subtext = optionsSetup.subText;
      title.subtextStyle = {
        color: optionsSetup.subTextColor,
        fontWeight: optionsSetup.subTextFontWeight,
        fontSize: optionsSetup.subTextFontSize || 12,
      };
      title.padding = [16, 24, 8, 24];
      this.options.title = title;
    },
    // 数值设定
    setOptionsValue() {
      console.log(1)
      const optionsSetup = this.optionsSetup;
      const series = this.options.series;
      for (const key in series) {
        if (series[key].type == "pie") {
          series[key].label = this.seriesLabel();
          series[key].labelLine = {show: optionsSetup.isShow};
        }
      }
      this.options.series = series
    },
    // 提示语设置 tooltip
    setOptionsTooltip() {
      const optionsSetup = this.optionsSetup;
      const tooltip = {
        trigger: "item",
        show: true,
        backgroundColor: 'rgba(45, 52, 70, 0.96)',
        textStyle: {
          color: optionsSetup.lineColor || '#FFF',
          fontSize: optionsSetup.fontSize
        },
        formatter: (params) => {
          console.log(params)
          return `${params.marker} ${params.name}:${this.$getThousandths(params.value)}${params?.data?.symbol || ''} (${params.percent}%)`;
        }
      };
      this.options.tooltip = tooltip;
    },
    // 图例操作 legend
    setOptionsLegend() {
      const optionsSetup = this.optionsSetup;
      const legend = this.options.legend;
      legend.show = optionsSetup.isShowLegend  || true;
      legend.left = optionsSetup.lateralPosition == "left" ? 0 : "right";
      legend.right = optionsSetup.lateralPosition == "right" ? 0 : "auto";
      legend.top = optionsSetup.longitudinalPosition == "bottom" ? 0 : "bottom";
      legend.bottom =
        optionsSetup.longitudinalPosition == "bottom" ? 0 : "auto";
      legend.orient = optionsSetup.layoutFront;
      legend.textStyle = {
        color: optionsSetup.lengedColor  || "#677392",
        fontSize: optionsSetup.fontSize
      };
      legend.padding = [24, 40, 24, 0 ]
      legend.itemWidth = optionsSetup.lengedWidth  || 12;
    },
    // 图例颜色修改
    setOptionsColor() {
      const optionsSetup = this.optionsSetup;
      const defaultColor =  [
                { color: "#8DAEFF" },
                { color: "#4278FF" },
                { color: "#55D2DE" },
                { color: "#3BD351" },
                 { color: "#89E496" },
                { color: "#87cefa" },
                { color: "#FBBC00" },
                { color: "#FCD666" },
                { color: "#E96469" },
                 { color: "#F1A2A5" },
                { color: "#C369EA" },
                { color: "#DBA5F2" },
              ];
      const customColor = optionsSetup.customColor ? optionsSetup.customColor : defaultColor;
      // const customColor = optionsSetup.customColor;
      if (!customColor) return;
      const arrColor = [];
      for (let i = 0; i < customColor.length; i++) {
        arrColor.push(customColor[i].color);
      }
      this.options.color = arrColor;
      this.options = Object.assign({}, this.options);
    },
    setOptionsData() {
      const optionsData = this.optionsData; // 数据类型 静态 or 动态
      if(optionsData.dataType == "staticData"){
          this.renderingFn(optionsData.staticData);
        }else if(optionsData.dataType == "dynamicData"){
          let oneTime = this.$once(this.renderingFn);
          oneTime(optionsData.staticData);
          // debugger;
          // 如果是新的数据，则还是利用旧数据进行渲染；
          if(optionsData.dynamicData && optionsData.dynamicData.contextData){
            this.dynamicDataFn(optionsData.dynamicData, optionsData.refreshTime)
          }          
        }
    },
    dynamicDataFn(val, refreshTime) {
      if (this.ispreview) {
        this.editorDataSet();
        // this.getEchartData(val);
      } else {
        if (!val  || !val.chartProperties || val.chartProperties.isVerified === false) return;
        this.getEchartData(val);
      }
    },
    getEchartData(val) {
      this.loading = true;
      const data = this.queryEchartsData(val.contextData,val.params,  val.chartProperties);
      data.then(res => {
        this.loading = false;
        this.renderingFn(res);
      }).catch(err => {
        this.loading = false;
      });
    },
    seriesLabel() {
      const that  = this;
      const optionsSetup = this.optionsSetup;
      return {
        show: optionsSetup.isShow,
        formatter: function(params) {
          const numberValue = optionsSetup.numberValue ? `{value|${that.$getThousandths(params.value)}${params?.data?.symbol || ''}}` : "";
          const percentage = optionsSetup.percentage ? `{percent|(${params.percent}%)}` : "";
          return `{name|${params.name}}: ${numberValue}${percentage}`;
        },
        rich: {
          percent: {
            color: optionsSetup.subTextColor,
            fontWeight: optionsSetup.fontWeight,
            fontSize: optionsSetup.fontSize,
          },
          value: {
            color: optionsSetup.subTextColor,
            fontWeight: optionsSetup.fontWeight,
            fontSize: optionsSetup.fontSize,
          }
        },
        lineHeight: 18,
        fontWeight: optionsSetup.fontWeight,
        fontSize: optionsSetup.fontSize,
        position: "outer",  
        alignTo: "edge",  
        margin: 10,
      }
    },
    renderingFn(val) {

      for (const key in this.options.series) {
        if (this.options.series[key].type == "pie") {
          this.options.series[key].data = val;
          this.options.series[key].top = 24;
          this.options.series[key].label = this.seriesLabel()
        }
      }
    }
  }
};
</script>

<style scoped lang="less">
.echarts {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
